export const SgmConfig = {
  Error: {
    scriptError: '1008', // Script Error
    jsError: '1009', // js 错误
  },
  Warning: {
  },
  Info: {},
};

export const sendSgmMta = (code, data) => {
  try {
    if(!code) return;

    const reportData = {
      ...(data || {}),
      realUrl: window.location.href,
    };
    window.__sgm__.custom({
      type: Number(code.slice(0, 1)),
      code,
      msg: JSON.stringify(reportData),
    });
  } catch (e) {}
};